export default __webpack_public_path__ + "static/media/home-page-1.9774150a.gif";